import Chart from "./Chart";
import CONFIG from "../../../config";
export const filterDomain = ["X轴", "Y轴", "系列"];
export const config = {
  name: "basicPieChart",
  archive: "图表",
  domain: "饼图/环形图",
  alias: "基础饼图",
  thumb: CONFIG.ASSET_BASE_URL + "/charts/basicPieChart.png",
};
export const option = () => ({
  title: {
    text: "饼图",
  },
  tooltip: {
    trigger: "item",
  },
  dataset: {
    source: [
      ["系列", "系列1"],
      ["名称2", 43.3],
      ["名称3", 83.1],
      ["名称4", 86.4],
      ["名称5", 72.4],
    ],
  },
  series: [
    {
      type: "pie",
      radius: "50%",
      labelLine: {
        show: true,
      },
      // emphasis: {
      //     itemStyle: {
      //         shadowBlur: 10,
      //         shadowOffsetX: 0,
      //         shadowColor: 'rgba(0, 0, 0, 0.5)'
      //     }
      // }
    },
  ],
});
export default (props) => {
  return <Chart defaultOption={option()} {...props} />;
};
